import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import 'amfe-flexible'
import "@/ts/SuperExt";
import Tools from './ts/Tools'
import Global from './ts/Global'
import Config from './ts/Config'
import VueDragResizeRotate from "@gausszhou/vue3-drag-resize-rotate";
import "@gausszhou/vue3-drag-resize-rotate/lib/bundle.esm.css";

let app = createApp(App);
app.use(VueDragResizeRotate as any);
app.use(store).use(Vant).use(router);

app.config.globalProperties.$R = (url: string | null | undefined, useProxy: boolean = false) => {
    return Global.GetResourceURL(url, useProxy);
};

(globalThis as any).scanAndroidtoH5 = (content: string) => {
    Global.OnScanAndroidtoH5 && Global.OnScanAndroidtoH5(content);
} 

Global.api.globalApi.GetSystemConfigAsync().then(async resp => {
    if (resp.CheckIsOk()) {
        const { ResourceFileHost, MinioResourceURL, MinioUseBucketName } = resp.Data!;
        Config.ResourceFileHost = ResourceFileHost;
        Config.MinioResourceURL = MinioResourceURL;
        Config.MinioUseBucketName = MinioUseBucketName;//存储桶名称
        app.mount('#app');
    }
});
